/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import wizardStyle from "@/src/components/Form/wizardStyle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { requiredValidator } from "@/src/services/validationRules";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type OtherAssetsProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function OtherAsset({ path, index, product }: OtherAssetsProps) {
  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Geben Sie hier bitte die Details zum {index + 1}. Vermögenswert an</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".name"}
          label="Bezeichnung"
          validators={[requiredValidator("Bitte geben Sie die Bezeichnung des Vermögenswerts an")]}
        />
      </Grid>
      <Grid size={12}>
        <ValidatorSelectField
          label="Allein- oder Miteigentum"
          name={path + ".ownership"}
          validators={[requiredValidator("Bitte geben Sie die Besitzverhältnisse an")]}
          MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
        >
          <MenuItem value={"Alleineigentum"}>Alleineigentum</MenuItem>
          <MenuItem value={"Miteigentum"}>Miteigentum</MenuItem>
        </ValidatorSelectField>
      </Grid>
      <NumberFieldConfigured fieldPath={path + ".value"} required caseData={product} fieldType={"money"} numberType={"float"} />
    </>
  );
}
